import r from"@babel/runtime-corejs3/helpers/esm/slicedToArray";import{useState as e,useLayoutEffect as o}from"react";var t=function(t,i){var m=e(t),n=r(m,2),a=n[0],c=n[1];return o((function(){c(i?i(t):t)}),[t]),[a,c]};export{t as useControlledLayoutEffect};
//# sourceMappingURL=useControlledLayoutEffect.js.map
